import { DotIcon } from "@primer/octicons-react";
import Prism from "prismjs";
import { useEffect } from "react";
import { Header, Share, Sidebar } from "../../components";

const DisplayMode = () => {
  useEffect(() => {
    Prism.highlightAll();
    document.title = "PWA Fire - Display Mode API";
  }, []);
  return (
    <article>
      <Header />
      <section className="docs-flex">
        <Sidebar />
        <section className="docs-flex-right fade-in docs post">
          <div className="date">
            <span>Last updated -: June 17 2022</span>
            <Share
              data={{
                url: "https://docs.pwafire.org/link/display-mode",
                title: "Badging API",
                text: "Check the display mode of your web app, for example, whether it is in fullscreen or not."
              }}
            />
          </div>
          <h3>Check web app display mode</h3>
          <p className="quote">
            Check the display mode of your web app, for example, whether it is
            in fullscreen or not.
          </p>
          <p>
            <DotIcon />
            Provide a callback function to be called when the display mode
            changes.
          </p>
          <pre id="copy-code">
            <code className="language-javascript">{`  // Display mode...
  displayMode((mode) => {
    // Do something...
  })`}</code>
          </pre>
        </section>
      </section>
    </article>
  );
};

export default DisplayMode;
